import React from 'react';

import Icon from 'app/components/atoms/Icon/Icon';
import { connect } from 'react-redux';

const TypeIcon = ({ type, size, color, primaryClasses }) => {
    const iconSize = size || 'sm';

    switch (type) {
        case 'iot_pipeline':
            return <Icon hexColor={color} name="pipe" size={iconSize} />;
        case 'graphic':
            return <Icon hexColor={color} name="folder-multiple-image" size={iconSize} />;
        case 'broadcast':
            return <Icon hexColor={color} name="bullhorn" size={iconSize} />;
        case 'relationdefinition':
            return <Icon hexColor={color} name="link" size={iconSize} />;
        case 'thing':
            return <Icon hexColor={color} name="Things" type="af" size={iconSize} />;
        case 'person':
            return <Icon hexColor={color} name="account-outline" type="mdi" size={iconSize} />;
        case 'workspace':
            return <Icon hexColor={color} name="set-left-center" size={iconSize} />;
        case 'user':
            return <Icon hexColor={color} name="account" size={iconSize} />;
        case 'team':
            return <Icon hexColor={color} name="account-group" size={iconSize} />;
        case 'organisation':
            return <Icon hexColor={color} name="organisations" type="af" size={iconSize} />;
        case 'custom':
            return <Icon hexColor={color} name="shape-circle-plus" size={iconSize} />;
        case 'class':
            return <Icon hexColor={color} name="Attribute-class" type="af" size={iconSize} />;
        case 'entityType':
            return <Icon hexColor={color} name="primary-class" type="af" size={iconSize} />;
        case 'customClassEntity':
            return <Icon hexColor={color} name="things" type="af" size={iconSize} />;
        case 'relation':
            return <Icon hexColor={color} name="link" size={iconSize} />;
        case 'task':
        case 'opentask':
        case 'closedtask':
            return <Icon hexColor={color} name="checkbox-marked-circle-outline" size={iconSize} />;
        case 'process':
        case 'openprocess':
        case 'closedprocess':
            return <Icon hexColor={color} name="processes" type="af" size={iconSize} />;
        case 'processDefinition':
            return <Icon hexColor={color} name="process-builder" type="af" size={iconSize} />;
        case 'event':
            return <Icon hexColor={color} name="event-monitor" type="af" size={iconSize} />;
        case 'eventtype':
            return <Icon hexColor={color} name="data-source-builder" type="af" size={iconSize} />;
        case 'channel':
            return <Icon hexColor={color} name="public-channel" type="af" size={iconSize} />;
        case 'group':
            return <Icon hexColor={color} name="private-channel" type="af" size={iconSize} />;
        case 'direct':
            return <Icon hexColor={color} name="Direct-message" type="af" size={iconSize} />;
        case 'boards':
            return <Icon hexColor={color} name="Kanban" type="af" size={iconSize} />;
        case 'live':
            return <Icon hexColor={color} name="headset" size={iconSize} />;
        case 'backgroundjob':
            return <Icon hexColor={color} name="coffee" size={iconSize} />;
        case 'print-template':
            return <Icon hexColor={color} name="printer" size={iconSize} />;
        default: {
            const primaryClass = primaryClasses.find(pcls => pcls.uri === type);
            if (primaryClass) return <Icon hexColor={primaryClass.color} name={primaryClass.icon} type={primaryClass.iconType} size={iconSize} />;
            return null;
        }
    }
};

export default connect(
    state => ({
        primaryClasses: state.app.allPrimaryClasses.records || [],
    }),
    {}
)(TypeIcon);
